export default __webpack_public_path__ + "media/maps/directions-c84526c2.svg";